/**
 * Capitalize inputs on keyup
 *  .capitalize-input class
 */
export default function initCapitalizeInput() {
    const inputsToCapitalize = document.getElementsByClassName('capitalize-input');
    if (inputsToCapitalize.length === 0) {
        return;
    }

    for (const elem of inputsToCapitalize) {
        elem.addEventListener('keyup', (event) => {
            // eslint-disable-next-line no-param-reassign
            event.target.value = event.target.value.toUpperCase();
        });
    }
}
